module.exports = __webpack_public_path__ + "media/assets/images/blog/Depositphotos_29430059_L-small-562131cb6c32cfdcbeec50139ad0745a.jpg";